import store from '@/store/index'

export default {}

/**
 * Returns the full state object of the user tracking module.
 *
 * @returns Object
 */
export const get = () => {
  return store.getters['admin/findUsersWidgetModule/get']
}

/**
 * Returns the sets of selected users.
 *
 * @return Object
 */
export const selectedUserSets = () => {
  return store.getters['admin/findUsersWidgetModule/userSelectionSets']
}

/**
 * Returns user names that are selected for the specified set.
 *
 * @param set String
 *
 * @return Array
 */
export const selectedUserNames = (set) => {
  if (store.getters['admin/findUsersWidgetModule/userSelectionSets'].hasOwnProperty(set)) {
    const users = store.getters['admin/findUsersWidgetModule/userSelectionSets'][set]
    let results = []

    for (let key in users) {
      if (users.hasOwnProperty(key)) {
        results.push(users[key].full_name)
      }
    }

    return results
  } else {
    return []
  }
}

/**
 * Returns users that are selected for the specified set.
 *
 * @param set String
 *
 * @return Object
 */
export const selectedUsers = (set) => {
  if (store.getters['admin/findUsersWidgetModule/userSelectionSets'].hasOwnProperty(set)) {
    return store.getters['admin/findUsersWidgetModule/userSelectionSets'][set]
  } else {
    return {}
  }
}

/**
 * Returns users that are selected for the specified set as an array
 *
 * @param set String
 *
 * @return Array
 */
export const selectedUsersAsArray = (set) => {
  if (store.getters['admin/findUsersWidgetModule/userSelectionSets'].hasOwnProperty(set)) {
    const users = store.getters['admin/findUsersWidgetModule/userSelectionSets'][set]
    const userIds = Object.keys(users)
    let results = []
    userIds.forEach(userId => {
      results.push(users[userId])
    })
    return results
  } else {
    return []
  }
}

/**
 * Returns the first selected user in the specified set or null if none is selected.
 *
 * @param set String
 *
 * @return Object|null
 */
export const selectedUser = (set) => {
  if (store.getters['admin/findUsersWidgetModule/userSelectionSets'].hasOwnProperty(set)) {
    const users = store.getters['admin/findUsersWidgetModule/userSelectionSets'][set]
    const userIds = Object.keys(users)
    if (userIds.length > 0) {
      return users[userIds[0]]
    } else {
      return null
    }
  } else {
    return null
  }
}

/**
 * Returns true if the specified user is selected within the supplied set.
 *
 * @param set String
 * @param id Integer
 *
 * @return Boolean
 */
export const isSelected = (set, id) => {
  return selectedUsers(set).hasOwnProperty(id)
}

/**
 * Load the status data of the users being tracked.
 *
 * @return Promise
 */
export const query = () => {
  return store.dispatch('admin/findUsersWidgetModule/query')
}

/**
 * Add a map or array of object users that have been selected within
 * the specified set.
 *
 * @param set String
 * @param users Array|Map
 */
export const addSelectedUsers = (set, users) => {
  store.commit('admin/findUsersWidgetModule/addSelectedUsers', { set, users })
}

/**
 * Removes an array of users from the set's list of selected users.
 * The array must consist of the id's of the users that are no
 * longer selected.
 *
 * @param set String
 * @param users Array
 */
export const removeSelectedUsers = (set, users) => {
  store.commit('admin/findUsersWidgetModule/removeSelectedUsers', { set, users })
}

/**
 * Return all selected users
 *
 * @param set
 * @returns {*}
 */
export const userSelectionSets = (set) => {
  return store.getters['admin/findUsersWidgetModule/userSelectionSets'][set]
}

/**
 * Clears all selected users within a specified set.
 */
export const clearSelectedUsers = (set) => {
  store.commit('admin/findUsersWidgetModule/clearSelectedUsers', set)
}

/**
 * Clears all selected users.
 */
export const clearAllSelectedUsers = () => {
  store.commit('admin/findUsersWidgetModule/clearAllSelectedUsers')
}

/**
 * Returns the selected user count for the specified set.
 *
 * @param set String
 *
 * @return Integer
 */
export const selectedUserCount = (set) => {
  return Object.keys(selectedUsers(set)).length
}

/**
 * Clears all users from being tracked.
 */
export const purge = () => {
  store.commit('admin/findUsersWidgetModule/purge')
}



// WEBPACK FOOTER //
// ./src/store/administration/users/findUsersWidget.helpers.js